import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
type FormSuccessProps = {
  title: string;
  children: React.ReactNode;
  onReset?: () => void;
  resetLabel?: string;
};
export function FormSuccess({
  title,
  children,
  onReset,
  resetLabel = 'Submit another'
}: FormSuccessProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.25,
    ease: [0.23, 1, 0.32, 1]
  }} className="tis-card p-10 text-center" role="status" data-id="element-57" data-mp="377flcedduapl">
      <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-b from-[#ff4a47] to-[#8f1a22] text-white shadow-[0_0_30px_rgba(255,40,50,.45)]" data-id="element-58" data-mp="3h2poj5fioo4y">
        <CheckIcon className="h-7 w-7" data-id="element-59" data-mp="3pwm584pwx8cz" />
      </span>
      <h2 className="mt-6 font-slab text-3xl font-black uppercase tracking-[0.04em]" data-id="element-60" data-mp="3uwqq06xusp90">{title}</h2>
      <div className="mx-auto mt-4 max-w-lg leading-relaxed text-ink-muted" data-id="element-61" data-mp="3pe81pp5c7s1">{children}</div>
      {onReset && <button type="button" onClick={onReset} className="mt-8 font-slab text-sm font-bold uppercase tracking-[0.2em] text-neon-2 underline underline-offset-8 hover:opacity-70" data-id="element-62" data-mp="hum7n0een081">
          {resetLabel}
        </button>}
    </motion.div>;
}